export default __webpack_public_path__ + "static/media/delete-roadmap.7cda905a.png";